<template>
  <!-- 创建新配方 -->
  <div class="drawer-content">
    <Form ref="formItem" :model="formItem" :rules="ruleValidate" label-position="top" class="info-data">
      <FormItem label="配方名字" prop="name">
        <Input v-model="formItem.name" placeholder="输入配方名字..." />
      </FormItem>
      <FormItem label="含固量（%）(例：45%则填45）" prop="solidContent">
        <InputNumber :min="0" :max="100" :step="1" v-model="formItem.solidContent" placeholder="45%则填45"
          style="width: 100%"></InputNumber>
      </FormItem>

      <FormItem label="A料滴加时间（秒）" prop="dijiaATime">
        <InputNumber :min="0" :step="1" v-model="formItem.dijiaATime" placeholder="输入A料滴加时间..." style="width: 100%">
        </InputNumber>
      </FormItem>

      <FormItem label="B料滴加时间（秒）" prop="dijiaBTime">
        <InputNumber :min="0" :step="1" v-model="formItem.dijiaBTime" placeholder="输入B料滴加时间..." style="width: 100%">
        </InputNumber>
      </FormItem>

      <FormItem label="C料滴加时间（秒）" prop="dijiaCTime">
        <InputNumber :min="0" :step="1" v-model="formItem.dijiaCTime" placeholder="输入C料滴加时间..." style="width: 100%">
        </InputNumber>
      </FormItem>

      <FormItem label="保温时间（秒）" prop="baowenTime">
        <InputNumber :min="0" :step="1" v-model="formItem.baowenTime" placeholder="输入保温时间..." style="width: 100%">
        </InputNumber>
      </FormItem>

      <FormItem label="中和时间（秒）" prop="zhongheTime">
        <InputNumber :min="0" :step="1" v-model="formItem.zhongheTime" placeholder="输入中和时间..." style="width: 100%">
        </InputNumber>
      </FormItem>

      <FormItem label="备注" prop="remark">
        <Input v-model="formItem.remark" placeholder="输入备注..." type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" />
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        <Button @click="$emit('closeDrawer')" style="margin-left: 8px">取消</Button>
      </FormItem>
    </Form>
    <div class="table-panel">
      <Table :columns="columns" :data="displayData" border show-summary :summary-method="handleSummary">
        <template slot-scope="{ row, index }" slot="ratio">
          <div v-if="row.name !== '水'">
            <InputNumber :max="100" :min="0" :step="0.1" v-model="recipeDetailList[index].ratio" class="input-ratio" />
            <span class="percentage-append">%</span>
          </div>
          <span v-else>{{ row.ratio }}%</span>
        </template>
        <template slot-scope="{ row }" slot="deleteBtn" style="padding-left: 0">
          <Icon v-if="row.name !== '水'" type="ios-remove-circle-outline" class="deleteBtn"
            @click="removeMaterialfromRecipe(row._id)" size="18" />
        </template>
      </Table>
    </div>
    <div class="material-list-block">
      <Input search clearable placeholder="搜索原材料..." style="margin: 0 4px" @on-search="searchMaterial"
        v-model="searchMaterialText" />
      <Divider orientation="left">原材料</Divider>
      <div class="material-list">
        <div @click="selectMaterial(i)" v-for="i in materialList.filter(
          (x) => x.type === 'raw' && x.usedForSemi === true
        )" :key="i._id" :class="{
          'm-cell': true,
          selected: displayData.map((e) => e._id).indexOf(i._id) !== -1,
        }">
          {{ i.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getMaterials } from "@/api/material";

export default {
  name: "EditSemiMaterialDrawer",
  data() {
    return {
      searchMaterialText: null,
      drawerOpened: false,
      materialList: [],
      material: {
        name: null,
      },
      newRecipe: {
        selectedMaterials: [],
      },
      water: null,
      recipeDetailList: [], // 用表格里的，展示各个原材料配比
      prodRecipe: null,
      semiRecipeList: [], // 母液配方列表
      selectedRecipe: null,
      formItem: {
        name: "",
        remark: "",
        solidContent: 1,
        dijiaATime: 0,
        dijiaBTime: 0,
        dijiaCTime: 0,
      },
      ruleValidate: {
        name: [{ required: true, message: "名字为必填项", trigger: "blur" }],
      },
      columns: [
        {
          title: "原材料",
          key: "name",
        },
        {
          title: "比例",
          key: "ratio",
          slot: "ratio",
          align: "right",
          width: 130,
        },
        {
          title: " ",
          key: "deleteBtn",
          slot: "deleteBtn",
          align: "left",
          width: 40,
        },
      ],
    };
  },
  computed: {
    sumRatio() {
      return this.recipeDetailList.reduce(
        (sum, row) => sum + (row.ratio || 0),
        0
      );
    },
    displayData() {
      if (this.water) {
        this.water.ratio = (100 - this.sumRatio).toFixed(2);
        return [...this.recipeDetailList, this.water];
      } else {
        return [...this.recipeDetailList];
      }
    },
  },
  methods: {
    handleSummary({ columns, data }) {
      return {
        name: {
          key: "name",
          value: "总和",
        },
        ratio: {
          key: "ratio",
          value: 100 + "%",
        },
        deleteBtn: {
          key: "deleteBtn",
          value: null,
        },
      };
    },
    async searchMaterial() {
      await getMaterials({
        searchText: this.searchMaterialText,
        usedForSemi: true,
      }).then((res) => {
        this.materialList = res.data.materialList;
      });
    },
    ...mapActions({
      createRecipeSemi: "recipeSemi/createRecipeSemiAction",
      getRecipeSemis: "recipeSemi/getRecipeSemisAction",
    }),

    async openDrawer(material, recipe) {
      this.material = material;
      this.drawerOpened = true;
      await getMaterials({}).then((res) => {
        this.materialList = res.data.materialList;
        this.water = {
          ...this.materialList.find((x) => x.type === "water"),
          ratio: 100,
        };
      });
      try {
        const res = await this.getRecipeSemis({ material: this.material._id });
        this.semiRecipeList = res.recipe;
        this.material = res.material;
        this.prodRecipe = res.material.recipeSemi;
        this.selectedRecipe = this.prodRecipe;
      } catch (error) {
        this.$Message.warning(`没有获取到对应配方`);
      }
      if (recipe) {
        this.formItem.solidContent = recipe.solidContent;
        this.formItem.dijiaATime = recipe.dijiaATime || 0;
        this.formItem.dijiaBTime = recipe.dijiaBTime || 0;
        this.formItem.dijiaCTime = recipe.dijiaCTime || 0;
        for (let i = 0; i < recipe.detail.length; i++) {
          if (recipe.detail[i].name !== "水") {
            this.selectMaterial(recipe.detail[i]);
          }
        }
      }
    },
    createNewRecipe() {
      this.$nextTick(function () {
        this.$refs.MaterialSelectPanel.open();
        this.recipeDetailList = [];
        this.$refs.formItem.resetFields();
        this.formItem = {
          name: "",
          remark: "",
          solidContent: 1,
          dijiaATime: 0,
          dijiaBTime: 0,
          dijiaCTime: 0,
        };
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          const detail = this.displayData.map((e) => {
            return { material: e._id, ratio: e.ratio / 100 };
          });
          let newRecipe = { ...this.formItem, detail: detail };
          newRecipe.material = this.material._id;
          try {
            const res = await this.createRecipeSemi(newRecipe);
            this.$Message.success("成功!");
            this.$emit("closeDrawer", res);
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    selectMaterial(material) {
      this.newRecipe.selectedMaterials.push(material);
      if (material.hasOwnProperty("ratio")) {
        this.recipeDetailList.push({
          ...material,
          ratio: material.ratio * 100,
        });
      } else {
        this.recipeDetailList.push({ ...material, ratio: 0 });
      }
    },
    removeMaterialfromRecipe(id) {
      this.recipeDetailList = this.recipeDetailList.filter((e) => e._id != id);
    },
  },
};
</script>

<style scoped lang="stylus">
.drawer-content
  height 100%
  width 100%
  overflow hidden
  display flex

.info-data
  padding 12px 0 16px 0 16px
  width 250px
  height 100%
  overflow-y auto

  > .sec-title ~ .sec-title
    margin-top 16px

  .sec-title
    margin-bottom 8px

.recipe-data
  padding 16px 16px 0 16px
  height 100%
  width 400px
  float left
  overflow-y auto
  margin-left 50px

.sec-title
  width 100%
  font-weight 800

.table-panel
  width 368px
  height 100%
  margin 20px

.material-select-panel
  width 350px
  height 100%
  float left

.input-ratio
  width 75px
  float left
  text-align right
  margin-right 4px

.percentage-append
  float right
  line-height 32px
  height 32px

.sumratio
  line-height 32px
  font-weight 500
  font-size 20px
  margin-right 4px

.sumratio-alert
  color red

.sumratio-nice
  color green

.deleteBtn
  cursor pointer

  &:hover
    color red

.message
  flex 1
  margin-top 12px

.info-data
  padding 0 16px 0 0
  width 250px
  height 100%
  float left
  overflow-y auto

.material-data
  max-height 100%
  width 400px
  float left
  overflow-y auto

.material-list-block
  padding 0 16px 0 16px
  height 100%
  width 318px
  // padding: 0 8px;
  float left
  overflow-y auto

.material-list
  display flex
  flex-wrap wrap
  align-content flex-start
  overflow-y auto
  margin-top 8px

.m-cell
  padding 8px
  margin 4px
  border 1px solid lightgray
  border-radius 4px
  cursor pointer

  &:hover
    color #0168fa
    border 1px solid #0168fa
    box-shadow 0 2px 4px rgba(209, 230, 250, 1)
    transition 0.2s

.selected
  color lightgray
  cursor default
  pointer-events none

.input-ratio
  width 75px
  float left
  text-align right
  margin-right 4px

.percentage-append
  float right
  line-height 32px
  height 32px

.sumratio
  line-height 32px
  font-weight 500
  font-size 20px
  margin-right 4px

.sumratio-alert
  color red

.sumratio-nice
  color green

.deleteBtn
  cursor pointer

  &:hover
    color red
</style>
